import React, { useState, useEffect, useRef } from "react";
import { Col, FormGroup, Row } from "react-bootstrap";
import { TextareaField } from "../Fields/TextareaField";
import { FieldGroup } from "../Groups/FieldGroup";
import { CheckboxField } from "../Fields/CheckboxField";
import { FileField } from "../Fields/FileField";
import { Condition } from "../Conditionals/Condition";
import { pickAtLeastOne, requiredField, requiredUpload } from "../Validation";
import { generalHint } from "../TicketingFormConstants";

export const CorporateForm = ( { values }) => {
    const corporateDocTypes = ["Photos", "Social media post","Graphic illustration", "Trade show", "Roll up", "Poster", "Flyer", "Other" ];
    const [projectNeeds, setProjectNeeds] = useState( []);

    useEffect ( () => {
        if (values["Project Needs"]) {
            setProjectNeeds ( values["Project Needs"] );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ values["Project Needs"] ] );

    useEffect ( () => {
        console.info({projectNeeds});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, projectNeeds);


    return <>
        <Row>
            {/* CORPORATE FORM HEADER */ }
            <Col md={ 12 }>
                <h1>Corporate Material</h1>
                <label id="corporateTemplates">
                    Corporate Templates
                </label>
                <div id="entry_info_box">
                    <p>
                        <b>
                            Many branded templates are available on <a href="https://wenet.werfen.com" target="_blank"
                                                                       rel="noopener noreferrer">WeNet</a>.
                        </b>
                    </p>
                    <ul>
                        <li>Company logos</li>
                        <li>PowerPoint templates</li>
                        <li>Letterhead</li>
                        <li>Business cards</li>
                    </ul>
                    <p>
                        Before continuing with this request, please check <a href="https://wenet.werfen.com"
                                                                             target="_blank"
                                                                             rel="noopener noreferrer">WeNet</a>.
                    </p>
                    <p>
                        <b>
                            If you were unable to find what you were looking for on WeNet, please answer the following
                            questions so we can help you.
                        </b>
                    </p>
                </div>
                <hr/>
                <TextareaField
                    fieldId="Corporate"
                    fieldLabel="Project description"
                    hint="What is the objective of the project/event? Please provide a short description."
                    fieldRequired={ true }
                    validator={ requiredField }
                />
            </Col>

            {/* PROJECT NEEDS (checkboxes) */ }
            <Col md={ 12 }>
                <FieldGroup
                    groupId="projectNeeds"
                    groupLabel="I need:"
                    groupName="Project Needs"
                    validator={ pickAtLeastOne }
                >
                    {/*<CheckboxField*/}
                    {/*    fieldId="Project Needs"*/}
                    {/*    fieldLabel="Printed materials"*/}
                    {/*    fieldValue="Printed materials"*/}
                    {/*/>*/}

                    {/*<CheckboxField*/}
                    {/*    fieldId="Project Needs"*/}
                    {/*    fieldLabel="Give-aways (gadgets)"*/}
                    {/*    fieldValue="Give-aways"*/}
                    {/*/>*/}

                    {/*<CheckboxField*/}
                    {/*    fieldId="Project Needs"*/}
                    {/*    fieldLabel="Animations (e.g. GIFs)"*/}
                    {/*    fieldValue="Animations"*/}
                    {/*/>*/}

                   {/* <CheckboxField
                        fieldId="Project Needs"
                        fieldLabel="WeNet story"
                        fieldValue="WeNet story"
                    />
*/}
                    <CheckboxField
                        fieldId="Project Needs"
                        fieldLabel="Photos"
                        fieldValue="Photos"
                        name={"Photos"}
                    />
                {/*</FieldGroup>*/}

                {/*<FieldGroup*/}
                {/*    groupId="Usage"*/}
                {/*    groupLabel="Digital materials to be used for:"*/}
                {/*    groupName="Project Usage"*/}
                {/*    validator={ pickAtLeastOne }*/}
                {/*>*/}
                {/*    <CheckboxField*/}
                {/*        fieldId="Project Usage"*/}
                {/*        fieldLabel="Email Banner"*/}
                {/*        fieldValue="Email Banner"*/}
                {/*    />*/}

                    {/*<CheckboxField*/}
                    {/*    fieldId="Project Usage"*/}
                    {/*    fieldLabel="WeNet"*/}
                    {/*    fieldValue="WeNet"*/}
                    {/*/>*/}

                    <CheckboxField
                        fieldId="Project Needs"
                        fieldLabel="Social media post"
                        fieldValue="Social media post"
                    />

                    <CheckboxField
                        fieldId="Project Needs"
                        fieldLabel="Graphic illustration"
                        fieldValue="Graphic illustration"
                    />

                    {/*<CheckboxField*/}
                    {/*    fieldId="Project Needs"*/}
                    {/*    fieldLabel="Corporate webpage update"*/}
                    {/*    fieldValue="Corporate webpage update"*/}
                    {/*/>*/}

                    {/*<CheckboxField*/}
                    {/*    fieldId="Project Usage"*/}
                    {/*    fieldLabel="Microsite"*/}
                    {/*    fieldValue="Microsite"*/}
                    {/*/>*/}

                    <CheckboxField
                        fieldId="Project Needs"
                        fieldLabel="A trade show booth graphics/layout"
                        fieldValue="Trade show"
                    />

                    {/*<CheckboxField*/}
                    {/*    fieldId="Project Usage"*/}
                    {/*    fieldLabel="A newsletter template"*/}
                    {/*    fieldValue="Newsletter template"*/}
                    {/*/>*/}

                    <CheckboxField
                        fieldId="Project Needs"
                        fieldLabel="Roll up"
                        fieldValue="Roll up"
                    />

                    <CheckboxField
                        fieldId="Project Needs"
                        fieldLabel="Poster"
                        fieldValue="Poster"
                    />

                    <CheckboxField
                        fieldId="Project Needs"
                        fieldLabel="Flyer"
                        fieldValue="Flyer"
                    />

                    <CheckboxField
                        fieldId="Project Needs"
                        fieldLabel="Other"
                        fieldValue="Other"
                    />
                </FieldGroup>
                <Condition when="Project Needs" itIncludes="Other">
                    <TextareaField
                        fieldId="Project Needs Other"
                        fieldLabel="Description"
                        fieldRequired={ true }
                        validator={ requiredField }
                    />
                </Condition>
            </Col>

            {/* PROJECT ATTACHMENTS */ }
            <Col md={ 12 }>
                <FormGroup id="projectAttachment_box">
                    {(projectNeeds.length > 0 ) && (projectNeeds.every(projectNeed=> corporateDocTypes.includes(projectNeed))) &&
                        <FileField
                            fileFieldId="projectAttachment_file"
                            fileFieldName="projectAttachment"
                            hint={ generalHint}
                            fileFieldLabel="File Upload"
                            fileFieldMultiple={ true }
                            validator={  requiredUpload }
                        />}

                </FormGroup>
            </Col>
        </Row>
    </>;
}
